import { useState } from 'react'
import { TryOnCamera } from '../../components/TryOn'
import { Button } from '../../components'
import { useCartContext } from '../../context'
import { getProductsByType } from '../../data/products'
import type { CoverColor } from '../../types'
import styles from './TryOnPage.module.css'

export function TryOnPage() {
  const [selectedColor, setSelectedColor] = useState<CoverColor>('blue')
  const { addItem, openCart } = useCartContext()

  const covers = getProductsByType('cover')
  const frames = getProductsByType('frame')

  const formatMXN = (val: number) => val.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })

  // Agrega el marco base negro + la cubierta seleccionada al carrito.
  const handleAddToCart = () => {
    const frame = frames[0]
    const cover = covers.find((c) => c.color === selectedColor)
    if (frame) addItem(frame)
    if (cover) addItem(cover)
    openCart()
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Prueba Virtual</h1>
        <p className={styles.subtitle}>
          Descubre cómo te quedan nuestras gafas antes de comprar
        </p>
      </header>

      <div className={styles.content}>
        <div className={styles.cameraSection}>
          <TryOnCamera selectedColor={selectedColor} onColorChange={setSelectedColor} />
        </div>

        <aside className={styles.sidebar}>
          <div className={styles.infoCard}>
            <h2 className={styles.infoTitle}>Cómo funciona</h2>
            <ol className={styles.steps}>
              <li>Activa tu cámara</li>
              <li>Posiciona tu rostro en el centro</li>
              <li>Selecciona el color de cubierta</li>
              <li>¡Prueba diferentes estilos!</li>
            </ol>
          </div>

          <div className={styles.productCard}>
            <h3 className={styles.productTitle}>Tu selección</h3>
            <div className={styles.productItem}>
              <span>Marco Base Negro</span>
              <span className={styles.price}>{frames[0] ? formatMXN(frames[0].price) : ''}</span>
            </div>
            <div className={styles.productItem}>
              <span>
                Cubierta{' '}
                {selectedColor === 'red'
                  ? 'Roja'
                  : selectedColor === 'yellow'
                    ? 'Amarilla'
                    : selectedColor === 'green'
                      ? 'Verde'
                      : 'Azul'}
              </span>
              <span className={styles.price}>
                {covers.find((c) => c.color === selectedColor) ? formatMXN(covers.find((c) => c.color === selectedColor)!.price) : ''}
              </span>
            </div>
            <div className={styles.divider} />
            <div className={styles.productTotal}>
              <span>Total</span>
              <span className={styles.totalPrice}>
                {formatMXN(
                  (frames[0]?.price || 0) +
                  (covers.find((c) => c.color === selectedColor)?.price || 0)
                )}
              </span>
            </div>
            <Button fullWidth onClick={handleAddToCart}>
              Añadir al carrito
            </Button>
          </div>

          <div className={styles.features}>
            <div className={styles.feature}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span>Privacidad garantizada</span>
            </div>
            <div className={styles.feature}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </svg>
              <span>Procesamiento en tiempo real</span>
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}
